// src/components/comments/CommentList.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import '../../styles/comments.css';
import api from "../../utils/api"; // Your centralized api

const CommentList = ({ comments, loading }) => {
  const [likes, setLikes] = useState({}); // ✅ Store likes per commentId

  useEffect(() => {
    const fetchLikes = async () => {
      try {
        const newLikes = {};

        for (const comment of comments) {
          const res = await api.get(`/api/comments/${comment.id}/likes`);
          newLikes[comment.id] = res.data.likes || 0; // likes count
        }

        setLikes(newLikes);
      } catch (error) {
        console.error('Error fetching likes:', error);
      }
    };

    if (comments.length > 0) {
      fetchLikes();
    }
  }, [comments]);

  const handleLike = async (commentId) => {
    try {

      const res = await api.post(`/api/comments/${commentId}/react`, {});

      if (res.status === 200 || res.status === 201) {
        const { liked } = res.data;
  
        // Update UI like count based on whether user liked or unliked
        setLikes(prev => ({
          ...prev,
          [commentId]: liked
            ? (prev[commentId] || 0) + 1
            : Math.max((prev[commentId] || 1) - 1, 0)
        }));
  
        console.log(`✅ Comment ${liked ? 'liked' : 'unliked'} successfully!`);
      } else {
        console.error('❌ Failed to like/unlike comment.');
      }
    } catch (error) {
      console.error('Error liking comment:', error);
    }
  };

  if (loading) {
    return <div className="comments-loading">Loading comments...</div>;
  }

  if (comments.length === 0) {
    return <div className="no-comments">No comments yet. Be the first to comment!</div>;
  }

  const getIMGURL = (url) => {
    if (!url) return '/default-avatar.png';
    
    if (url.startsWith('ipfs://')) {
      // Extract the CID (Content ID) from the IPFS URL
      const cid = url.replace('ipfs://', '');
      // Use a public IPFS gateway
      return `https://ipfs.io/ipfs/${cid}`;
    }
    
    return url;
  }

  return (
    <div className="comments-list">
      {comments.map(comment => {
        const time = formatDistanceToNow(new Date(comment.createdAt), { addSuffix: true });

        return (
          <div key={comment.id} className="comment-item">
            <div className="comment-avatar">
              <Link to={`/profile/${comment.user.username}`}>
                <img 
                  src={getIMGURL(comment.user.profilePic) || '/default-avatar.png'} 
                  alt={comment.user.username} 
                />
              </Link>
            </div>

            <div className="comment-content">
              <div className="comment-header">
                <Link to={`/profile/${comment.user.username}`} className="comment-author">
                  {comment.user.displayName || comment.user.username}
                </Link>
                <span className="comment-time">{time}</span>
              </div>

              <div className="comment-text">{comment.text}</div>

              <div className="comment-actions">
                <button
                  className="comment-like"
                  onClick={() => handleLike(comment.id)}
                >
                  Like {likes[comment.id] ? `(${likes[comment.id]})` : ""}
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CommentList;
